import { render, staticRenderFns } from "./profile-update-required-popup.vue?vue&type=template&id=2e23741d&"
import script from "./profile-update-required-popup.vue?vue&type=script&lang=js&"
export * from "./profile-update-required-popup.vue?vue&type=script&lang=js&"
import style0 from "./profile-update-required-popup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports